import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ChevronDownIcon = React.forwardRef(function ChevronDownIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M12 16.32L4.35001 9.76001C3.93001 9.40001 3.88001 8.77001 4.24001 8.35001C4.60001 7.93001 5.23001 7.88001 5.65001 8.24001L12 13.68L18.35 8.24001C18.77 7.88001 19.4 7.93001 19.76 8.35001C20.12 8.77001 20.07 9.40001 19.65 9.76001L12 16.32Z"></path>
    </svg>
  )
})

ChevronDownIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ChevronDownIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ChevronDownIcon
